<template>
  <v-form
    ref="simpleForm"
    v-model="isValid"
    class="d-flex flex-column align-center justify-center"
  >
    <div class="mb-2 d-flex flex-column flex-md-row align-center">
      <v-subheader class="mr-md-3 field-label d-flex justify-center justify-md-end text-center text-md-end">
        {{ matriculationNrQuestion.text }}
      </v-subheader>
      <div>
        <div v-if="!isMobile" style="height: 22px;"></div>
        <v-text-field
          v-model="matriculationNr"
          :rules="matriculationNrQuestion.rules"
          :placeholder="matriculationNrQuestion.placeholder"
          dense
          filled
          rounded
          solo
          flat
          class="text-input"
          @input="updateEvent"
        />
      </div>
    </div>
    <div class="mb-2 d-flex flex-column flex-md-row align-center">
      <v-subheader class="mr-md-3 field-label d-flex justify-center justify-md-end text-center text-md-end">
        {{ registrationNrQuestion.text }}
      </v-subheader>
      <div>
        <div v-if="!isMobile" style="height: 22px;"></div>
        <v-text-field
          v-model="registrationNr"
          :rules="registrationNrQuestion.rules"
          :placeholder="registrationNrQuestion.placeholder"
          dense
          filled
          rounded
          solo
          flat
          class="text-input"
          @input="updateEvent"
        />
      </div>
    </div>
    <div v-if="showDateField" class="d-flex flex-column flex-md-row align-center">
      <v-subheader class="mr-md-3 field-label d-flex justify-center justify-md-end text-center text-md-end">
        {{ rcaDateExpirationQuestion.text }}
      </v-subheader>
      <div>
        <div v-if="!isMobile" style="height: 22px;"></div>
        <date-question
          top
          @updateDate="updateDate"
        />
      </div>
    </div>
  </v-form>
</template>

<script>
import { vehicleQuestions } from '@/_utils/static-data';
import DateQuestion from '@/components/DateQuestion';
export default {
  name: 'SimpleVehicleForm',
  components: { DateQuestion },
  props: {
    showDateField: Boolean
  },
  data() {
    return {
      matriculationNr: null,
      registrationNr: null,
      isValid: false,
      validExpirationDate: !this.showDateField,
      expirationDate: null,
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ]
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.width < 961;
    },
    matriculationNrQuestion() {
      return this.getQuestionById(1);
    },
    registrationNrQuestion() {
      return this.getQuestionById(2);
    },
    rcaDateExpirationQuestion() {
      return this.showDateField ? this.getQuestionById(10) : null;
    }
  },
  methods: {
    updateDate({ data, isValid }) {
      this.expirationDate = data?.formattedDate;
      this.validExpirationDate = isValid;
      this.updateEvent();
    },
    updateEvent() {
      setTimeout(() => {
        const data = [
          {
            questionText: this.matriculationNrQuestion.text,
            text: this.matriculationNr
          },
          {
            questionText: this.registrationNrQuestion.text,
            text: this.registrationNr
          }
        ];
        if (this.showDateField) {
          data.push({
            questionText: this.rcaDateExpirationQuestion.text,
            text: this.expirationDate
          });
        }
        this.$emit('updateData', {
          data,
          isValid: this.isValid && this.validExpirationDate
        });
      });
    },
    getQuestionById(id) {
      return vehicleQuestions(id)?.[0];
    }
  }
};
</script>

<style scoped>
.text-input {
  border-radius: 4px;
  width: 355px;
}
.text-input ::v-deep input {
  border: none;
}
.field-label {
  width: 150px;
}
@media screen and (max-width: 600px) {
  .field-label {
    width: 100%;
  }
  .text-input {
    width: 100%;
    min-width: 260px;
  }
}
</style>
